import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import ReactPaginate from "react-paginate";
import { compareAsc, format } from 'date-fns'
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { getSkillByDeptID } from '../Skills/subSkills/api/calls';
import jwt_decode from 'jwt-decode';
import Select from 'react-select'
function AttendanceApprovalComp() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userInformationData = jwt_decode(token.value);
    const userId = localStorage.getItem('userId');
    const [searchemail, setSearchemail] = useState('');
    const [user,setUser] = useState()
    const [dept, setDept] = useState([]);
    const [deptid, setDeptid] = useState('');
    const [empatt, setEmpatt] = useState([]);
    const [skill, setSkill] = useState('');
    const [skillsList, setSkillsList] = useState([]);
    const [modalstatus, setModalstatus] = useState(false);
    const [modalcomment, setModalcomment] = useState(false);
    const [remark, setRemark] = useState('')
    const [id_att, setId_att] = useState('');
    const [err, setErr] = useState('');
    const [msg, setSmg] = useState('');
    const [att_remark, setAtt_remark] = useState('')
    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions
    const dept_id = get_oermission_data.login_Permission.user_data.deptId



    const gettoken = localStorage.getItem('key');
    const token_data = jwt_decode(gettoken);
    const systemRole = token_data.systemRole


    // console.log('token_data',token_data.shift)

    const pagination = useRef();
    const [totalitem, setTotalitem] = useState('');
    const [searchbytext, setSearchbytext] = useState('')
    const [perPage, setPerpage] = useState(10);
    const [pages, setPages] = useState(1);
    const [options3, setOptions3] = useState([])

    const filterRequest = async () => {
        getHrAttendance(1,searchbytext)
    }
    const Reset_filter = () => {
        setSearchbytext('');
        setPage(1)
        setDeptid('')
        setSkill('')
        setUser('')
       getHrAttendance(1, '')
    
      }
    const getDepartmentWishEmpList = () => {
        const response = fetch(SERVER_URL + `api/common/department-wish-emp-list`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    userId: userId,
                  }),
            }).then(res => res.json())
            .then(data => {
               
                //setDepdata(data.result)
                const SelfDeptEmpList = data.result ? data.result :[]
                
                   if(SelfDeptEmpList.length > 0){
                    const newOptions3 = SelfDeptEmpList.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }));
                      setOptions3(newOptions3);
                   }else{
                    setOptions3([]);
                   }
               
            });
    }
    const handleAddSelfDeptEmpOption = (SelfInputValue) => {
        const newOption3 = { value: SelfInputValue.toLowerCase(), label: SelfInputValue };
        setOptions3((prevOptions3) => [...prevOptions3, newOption3]);
        return newOption3;
      };
    const handleSelfDeptUserChange = (SelfEmpOption) => {
        setUser(SelfEmpOption?SelfEmpOption.value:userId)
    };
    const setPage = ({ selected }) => {
        getHrAttendance(selected + 1,searchbytext)
        setPages(selected + 1)
    }
    useEffect(() => {
        // console.log('dept', dept)
        // console.log('systemRole', systemRole)
        getHrAttendance(1,searchbytext)
        setPages(pages)
        getDepartment()
        if(userInformationData.systemRole === 3 || userInformationData.systemRole === 8){
            getDepartmentWishEmpList()
        }
    }, [])
    const getDepartment = async () => {
        await fetch(SERVER_URL + `api/common/department_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                //console.log(data.result,'deparmtnet=====::')
                if (data.status === true) {
                    setDept(data.result)
                } else {
                    setDept([])
                }

            })
    }
    function handleChange(deptid) {
        setDeptid(deptid)
        getSkillByDeptID(deptid).then((res) => {
            if (res.status) {
                setSkillsList(res.data);
            }
        })
    }
    const getHrAttendance = async (pageNo,searchbytext1) => {
        // console.log('systemRole', systemRole)
        // console.log('dept', dept_id)
        // console.log('userId', userId)
        // console.log('searchemail', searchbytext1)
        const response = await fetch(SERVER_URL + `api/leave/all-attendance-history?query=${searchbytext1 ? searchbytext1 : ''}&page=${pageNo}&division=${deptid ? deptid : ''}&department=${skill ? skill : ''}&systemRole=${systemRole}&userId=${userId}&empID=${user?user:''}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                // console.log('data=======data=======data', data)
                if (data.status == true) {
                    setTotalitem(data.leaveTotal);
                    setEmpatt(data.data)
                }
            });
    }
    const leave_type_arr = ["", "Earned Leave", "Casual Leave", "Sick Leave", "Leave Without Pay", "Vacation Holiday"];
   
    const handleApproved = (id, empId, fromDate, toDate, leaveType, duration_type) => {
        fetch(SERVER_URL + `api/leave/leave-update-status`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id,
                    leaveType: leaveType,
                    duration_type: duration_type,
                    statusValue: 1,
                    shift: token_data.shift,
                    empId: empId,
                    formDate: fromDate,
                    toDate: toDate,
                    requestType: 3,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getHrAttendance(pages,searchbytext)
                } else {
                    alert(data.message)
                }
            });
    }
    const handleReject = (id) => {
        setSmg('');
        setId_att(id)
        setModalstatus(true)
    }
    const handleClose = () => {
        setModalcomment(false)
        setAtt_remark('')
        setModalstatus(false)
        setRemark('');
        setId_att('')
    }

    const handleRejectUpdate = () => {
        fetch(SERVER_URL + `api/leave/leave-rejected`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id_att,
                    statusValue: 3,
                    remark: remark,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setErr('green');
                    setSmg('Attendance successfully Reject!')
                    setTimeout(function () {
                        getHrAttendance(pages,searchbytext)
                        handleClose()
                    }, 1000);
                }
            });
    }
    const handleMSG = (id) => {
        const response = fetch(SERVER_URL + `api/leave/get-leave-remark`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setAtt_remark(data.data.remark)
                }
            })
        setModalcomment(true)

    }
    const dateConverter = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result > 1 ? result + ' Days' : result + 'Day'
    }
    const handleRegularise = (id, userId, reg_date, reg_start_time, reg_end_time, att_id) => {
        //        alert('ok ok'+id+' user id'+userId+'date:'+reg_date+'s_time'+reg_start_time+'end_time:'+reg_end_time)
        //   return false;
        const response = fetch(SERVER_URL + `api/attendance/timesheet-approved`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    RequestID: id,
                    RequestUserID: userId,
                    action: 1,
                    requestType: 2,
                    attId: att_id > 0 ? att_id : '',
                    attUserID: userId,
                    startTime: reg_start_time,
                    endTime: reg_end_time,
                    attDate: reg_date,
                    user_shift_time: get_oermission_data?.login_Permission?.user_data?.user_shift_time
                }),
            }).then(res => res.json())
            .then(data => {

                if (data.status == true) {
                    getHrAttendance(pages,searchbytext)
                }
            })

    }
    
    //console.log(empatt,'employee Apply list::')
    return (
        <>
            <Modal show={modalcomment} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-3">
                        <textarea value={att_remark} className="form-control" placeholder="" >{att_remark}</textarea>
                    </div>
                </div>
            </Modal>
            <Modal show={modalstatus} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross fw-bold"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div className="dash_white_box_ttl text-left mb10" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-3">
                        <textarea value={remark} onChange={(e) => { setRemark(e.target.value) }} className="form-control" placeholder="" >{remark}</textarea>
                    </div>
                    <div className="modalfooter">
                        <span className="d-block mb10 text-right" style={{ color: err }}>{msg}</span>
                        <div className="row">
                            <div className="col-md-6 pr07">
                                <button type="button" onClick={handleRejectUpdate} className="btn_5 w-100">Add</button>
                            </div>
                            <div className="col-md-6 pl07">
                                <button type="button" onClick={handleClose} className="btn_6 w-100" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
            <div className="page-header">
                <h1>
                    {/* <Link className="btn_5 mr10 float-end" to='/addemployee'>Add Employee</Link> */}
                    Attendance Approval</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Attendance Approval
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="dash_white_box2 mb20 p20">
                    <div className="dash_white_box_ttl">Search</div>
                    <div className="row mb10">
                    {
                            userInformationData.systemRole === 6 ?
                            <>
                        <div className="col-lg-3 col-md-6 pr07">
                            <label className="form-label">Employee Name / Code</label>
                            <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name' />
                            {/* <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name/code' /> */}
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <label className="form-label">Division</label>
                            <div className="form-input">
                                <select onChange={e => handleChange(e.target.value)} value={deptid} className="form-select">
                                    <option value=''>Select Division </option>
                                    {
                                        dept?.map((item, ind) => {
                                            return <option key={ind + 1} value={item.id}>{item.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 pl07 pr07">
                            <label className="form-label"> Department</label>
                            <div className="form-input">
                                <select value={skill} className="form-select" onChange={e => { setSkill(e.target.value) }}>
                                    <option value=''>Select Department </option>
                                    {
                                        skillsList.map((item, ind) => {
                                            return <option key={ind} value={item.id}>{item.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                       </> :''
                    }
                        {
                            userInformationData.systemRole === 3 || userInformationData.systemRole === 8 ?
                            <>
                            <Select style={{ width: "180px" }} className="mr05 selectcustom_width"
                               options={options3}
                               onChange={handleSelfDeptUserChange}
                               isSearchable={true}
                               placeholder="Search Employee"
                               isClearable
                               onCreateOption={handleAddSelfDeptEmpOption}
                               formatCreateLabel={(inputValue) => `Add \"${inputValue}\"`}
                               isValidNewOption={(inputValue, options) =>
                               !!inputValue && !options.some((option) => option.label === inputValue)
                               }
                           />
                           </>
                           :""
                        }
                        <div className="col-lg-3 col-md-6 pr07">
                            <label className="h49 mb10"></label>
                            <button onClick={filterRequest} className="btn_5 mr08">Search</button>
                            <button className="btn_6" onClick={Reset_filter}>Reset</button>
                        </div>
                    </div>

                </div>
                <div className="row mb30">
                    <div className="col-md-12">
                        <table className="table_style_1">
                            <thead>
                                <tr>
                                    <th>Employee</th>
                                    <th>Department </th>
                                    {/* <th>Leave Type	</th> */}
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th style={{ width: "170px" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    empatt?.map((item, ind) => {
                                        //  console.log(item,'item=========Update list')
                                        const Plan_startDate = moment(item.from_date).format('yyyy-MM-DD')
                                        const Plan_EndDate = moment(item.to_date).format('yyyy-MM-DD')
                                        return <tr key={ind + 1}>
                                            <td>{item.name ? `${item.name}` : ''} ({item.user_code ? item.user_code : 'N/A'})</td>
                                            <td>{item.department_name}</td>
                                            {/* <td>
                                                {item.request_type == 2 && <span className="avatar_icon">Rg</span>}
                                                {item.request_type != 2 && <span className="avatar_icon">{leave_type_arr[item.leave_type] ? leave_type_arr[item.leave_type].match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>}

                                            </td> */}
                                            <td>
                                                {/* {item.request_type != 2 &&
                                                    <span>
                                                        {moment(item.from_date).format('DD MMM, yyyy')} - {moment(item.to_date).format('DD MMM, yyyy')}-({dateConverter(new Date(item?.to_date), new Date(item?.from_date))})
                                                    </span>
                                                } */}
                                                {/* {item.request_type == 3  ?  <span>
                                                        {moment(item.from_date).format('DD MMM, yyyy')} - {moment(item.to_date).format('DD MMM, yyyy')}-({dateConverter(new Date(item?.to_date), new Date(item?.from_date))})
                                                    </span>:''} */}
                                                {item.request_type == 2 ? moment(item.regularize_date).format('DD MMM, yyyy') + ' (' + moment(item.start_time, ["HH:mm"]).format("hh:mm A") + ')-(' + moment(item.end_time, ["HH:mm"]).format("hh:mm A") + ')' : ''}
                                                {item.request_type == 3 && item.duration_type === 2 ? moment(item.from_date).format('DD MMM, yyyy') + '-' + moment(item.to_date).format('DD MMM, yyyy') + ' - (0.5 Half)' : ''}
                                                {item.request_type == 3 && item.duration_type === 1 ? moment(item.from_date).format('DD MMM, yyyy') + '-' + moment(item.to_date).format('DD MMM, yyyy') + ' - (' + dateConverter(new Date(item?.to_date), new Date(item?.from_date)) + ')' : ''}
                                                {/* {item.request_type == 2 && <span>
                                                    {moment(item.regularize_date).format('DD MMM, yyyy')} ({moment(item.start_time, ["HH:mm"]).format("hh:mm A")}-{moment(item.end_time, ["HH:mm"]).format("hh:mm A")})
                                                </span>
                                                } */}
                                            </td>
                                            <td>
                                                {(function () {
                                                    if (item.status == 1) {
                                                        return <span className="badge bg-success fontweight_n">Approved </span>
                                                    }
                                                    else if (item.status == 3) {
                                                        return <span className="badge bg-danger fontweight_n">Rejected</span>
                                                    }
                                                    else {
                                                        return <span className="badge bg-warning fontweight_n">Pending</span>
                                                    }
                                                })()}
                                            </td>
                                            <td style={{ width: '150px' }}>
                                                {(
                                                    function () {
                                                        if (item.status == 0 && item.request_type == 2) {
                                                            return hr_permission?.includes('29') && (<button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve </button>)
                                                        }
                                                        if (item.status == 1 && item.request_type == 2) {
                                                            return '';
                                                        }
                                                        else if (item?.status == 3) {

                                                            return <><button className="btn_8 mr05 btniconi" onClick={(e) => { handleMSG(item.id) }}><i className='icon icon-bubbles'></i></button><button className="btn_7 mr03 btniconi" onClick={(e) => { handleApproved(item.id, item.user_id, Plan_startDate, Plan_EndDate, item.leave_type, item.duration_type) }}><i className='icon icon-check'></i></button></>
                                                        } else {
                                                            if (item.request_type != 3) {
                                                                return <><button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button></>

                                                            }
                                                            if (item.request_type !== 2 || item.request_type !== 1) {

                                                                if (hr_permission.includes('29') && hr_permission.includes('30')) {

                                                                    return <>
                                                                        {(hr_permission?.includes('29') && item.status != 1) && (<button className="btn_7 mr03" onClick={(e) => { handleApproved(item.id, item.user_id, Plan_startDate, Plan_EndDate, item.leave_type, item.duration_type) }}>Approve</button>)}

                                                                        {hr_permission?.includes('30') && item.status != 1 && (<button className="btn_8" onClick={(e) => { handleReject(item.id) }} >Reject</button>)}
                                                                    </>
                                                                }
                                                                if (hr_permission.includes('29') && !hr_permission.includes('30')) {
                                                                    return <>
                                                                        {hr_permission?.includes('29') && (<button className="btn_7 mr03" onClick={(e) => { handleRegularise(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'), item.start_time, item.end_time, item.att_id) }}>Approve</button>)}
                                                                    </>
                                                                }
                                                                if (!hr_permission.includes('29') && hr_permission.includes('30')) {
                                                                    return <>
                                                                        {hr_permission?.includes('30') && (<button className="btn_8" onClick={(e) => { handleReject(item.id) }} >Reject</button>)}
                                                                    </>
                                                                }
                                                            }

                                                        }
                                                    })()}
                                            </td>
                                        </tr>
                                    })
                                }
                                {empatt.length < 1 && <tr ><td colSpan={6}><center>No record found</center></td></tr>}
                            </tbody>
                            <tfoot>


                                <tr><td colSpan="8" >
                                    <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                                    <ReactPaginate
                                        ref={pagination}
                                        pageCount={Math.ceil(totalitem / perPage)}
                                        pageRangeDisplayed={4}
                                        marginPagesDisplayed={1}
                                        onPageChange={setPage}
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        pageLinkClassName="page-link"
                                        breakLinkClassName="page-link"
                                        nextLinkClassName="page-link"
                                        previousLinkClassName="page-link"
                                        pageClassName="page-item"
                                        breakClassName="page-item"
                                        nextClassName="page-item"
                                        previousClassName="page-item"
                                        previousLabel={<>&laquo;</>}
                                        nextLabel={<>&raquo;</>}
                                    />
                                </td></tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AttendanceApprovalComp
